module.exports = __webpack_public_path__ + "static/media/face-desktop.a691628e.webp";